const changeJobNameStatusSelector = (
    state: sage.state.IRedux
): "loading" | "error" | "none" => {
    return state.jobs.changeJobNameStatus;
};

export default changeJobNameStatusSelector;
